import { gql } from '@apollo/client/core/index.js'

export const mutations = {
  CREATE_AUDIENCE: gql`
    mutation SELECT_CreateAudience(
      $advertiser_id: Int!
      $audience_type: AudienceTypeEnum!
      $is_hidden: Boolean
      $marketing_objective: AudienceMarketingObjectiveEnum
      $update: AudienceUpdateInput!
    ) {
      createAudience(
        advertiser_id: $advertiser_id
        audience_type: $audience_type
        is_hidden: $is_hidden
        marketing_objective: $marketing_objective
        update: $update
      ) {
        __typename
        ... on ThirdPartyAudience {
          audience_id
          name
        }
      }
    }
  `,
  PREVIEW_AUDIENCE: gql`
    mutation SELECT_PreviewAudience(
      $audience_id: Int
      $audience_type: AudienceTypeEnum!
      $update: AudienceUpdateInput!
      $skip_cache: Boolean
    ) {
      previewAudience(
        audience_id: $audience_id
        audience_type: $audience_type
        update: $update
        skip_cache: $skip_cache
      ) {
        __typename
        ... on ThirdPartyAudience {
          id
          audience_id
          name
          available_audience_size
          total_users
          audience_type
        }
      }
    }
  `,
}

export const queries = {
  GET_KEYWORDS: gql`
    query SELECT_GetKeywords($search: [String!]!, $advertiser_id: Int!) {
      getKeywords(search: $search, advertiser_id: $advertiser_id) {
        keyword
        description
        dataSourceId: data_source_id
        dataSourceCategoryId: data_source_category_id
        devices
        isMagic: is_magic
        parentKeywords: parent_keywords
      }
    }
  `,
  GET_GEO_LOCATION_LIST: gql`
    query SELECT_GetGeoLocationList($filter: GeoLocationFilter) {
      getGeoLocationList(filter: $filter) {
        id
        locationId: location_id
        location
        subLocation1: sub_location1
        subLocation2: sub_location2
        locationType: location_type
        devices
      }
    }
  `,
  GET_DEFAULT_SELECT_AUDIENCE: gql`
    query SELECT_GetDefaultSelectAudience(
      $filter: AudienceFilterInput!
      $limit: Int
    ) {
      getAudiences(filter: $filter, limit: $limit) {
        rows {
          __typename
          ... on ThirdPartyAudience {
            audience_id
          }
        }
      }
    }
  `,
  // One batch call that brings back all fields needed to construct the preview `update`
  GET_AUDIENCES: gql`
    query SELECT_GetAudiences(
      $filter: AudienceFilterInput!
      $limit: Int
      $page: Int
      $sort_by: String
      $sort_order: SortEnum
    ) {
      getAudiences(
        filter: $filter
        page: $page
        limit: $limit
        sort_by: $sort_by
        sort_order: $sort_order
      ) {
        count
        rows {
          __typename
          ... on ThirdPartyAudience {
            id
            audience_id
            name
            audience_type
            total_users
            expression
            interest {
              include { or { data_source_id cat __typename } __typename }
              exclude { or { data_source_id cat __typename } __typename }
              __typename
            }
            geo {
              include {
                ... on GeoLocation { id __typename }
                ... on GeoFile { id __typename }
                __typename
              }
              exclude {
                ... on GeoLocation { id __typename }
                ... on GeoFile { id __typename }
                __typename
              }
              radii_include {
                ... on GeoRadiusFile { id __typename }
                __typename
              }
              radii_exclude {
                ... on GeoRadiusFile { id __typename }
                __typename
              }
              __typename
            }
          }
          # First party rows may appear; we ignore them at service layer.
          ... on FirstPartyAudience { id name total_users __typename }
        }
      }
    }
  `,
}
